module.exports = __webpack_public_path__ + "img/Feature.5a93d425.png";